import { render, staticRenderFns } from "./ContadoresComponent.vue?vue&type=template&id=819b202c&"
import script from "./ContadoresComponent.vue?vue&type=script&lang=js&"
export * from "./ContadoresComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/franciscoriquelme/Documents/Elipse.ia/Proyectos/elipse-citas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('819b202c')) {
      api.createRecord('819b202c', component.options)
    } else {
      api.reload('819b202c', component.options)
    }
    module.hot.accept("./ContadoresComponent.vue?vue&type=template&id=819b202c&", function () {
      api.rerender('819b202c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Dashboard/ContadoresComponent.vue"
export default component.exports